import React, { useMemo } from 'react';

// helpers
import useTranslation from 'hooks/useTranslation';
import { OrganizationAddressTypes } from 'enums/onboarding/crm';
import { FormSelectProps, SelectOption } from '@ui';
// components
import { FormSelect } from '@ui';

export type IProps = FormSelectProps;

const OrganizationAddressTypeSelect = (props: IProps) => {
  const { t } = useTranslation('onboarding');

  const options = useMemo<SelectOption[]>(
    () =>
      Object.values(OrganizationAddressTypes).map((key) => ({
        id: key,
        label: t(`identification.organization_address_types.${key}`),
      })),
    [t],
  );

  return <FormSelect {...props} options={options} />;
};

export default OrganizationAddressTypeSelect;
